module.exports = __webpack_public_path__ + "static/media/img-107.e0b8aa19.jpg";